import ApiService from "@/core/services/api.service";
export const file = {
    uploadFile: (data = null) => {
        return ApiService.post("file/upload", data)
    },
}
